module.exports = function (value, array, options) {
  if ($.inArray(value, array) !== -1) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
};
